import { Box, Button, SxProps, Theme, useTheme } from "@mui/material";
import { SeriesModel } from "services/organizationPortalClient";
import { FormattedMessage as T, useIntl } from "react-intl";
import AddIcon from "@mui/icons-material/Add";
import BadgeIcon from "../../../../public/badge.png";
import useGlobalContext from "hooks/globalData";
import { Link } from "react-router-dom";

const useStyles = (theme: Theme): { [key: string]: SxProps } => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 1,
  },
  modules: {
    fontSize: "smaller",
    p: 1,
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  title: {
    fontWeight: "bold",
    flexGrow: 1,
    px: 1,
  },
  credits: {
    textAlign: "center",
    fontSize: "smaller",
    py: 1,
    borderBottom: `1px solid ${theme.palette.primary.main}`,
  },
  registerButton: {
    width: "100%",
  },
});

export default function SeriesTile(series: SeriesModel) {
  const { formatMessage: t } = useIntl();
  const { seriesDetailsEnrollUsersUrl } = useGlobalContext();
  const styles = useStyles(useTheme());
  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.modules}>
        <Box
          component="img"
          sx={{
            height: 24,
            width: 24,
          }}
          src={BadgeIcon}
        />
        <Box>{t({ id: "modules" }, { modulesCount: series.modulesCount })}</Box>
      </Box>
      <Box sx={styles.title}>{series.title}</Box>
      <Box sx={styles.credits}>
        <T id="credits" />: {series.credits?.toFixed(2)}
      </Box>
      <Link to={seriesDetailsEnrollUsersUrl(series.id)}>
        <Button
          variant="text"
          startIcon={<AddIcon />}
          sx={styles.registerButton}
        >
          <T id="register" />
        </Button>
      </Link>
    </Box>
  );
}
